import { render, staticRenderFns } from "./AccordiDataTable.vue?vue&type=template&id=5afd2f3e&scoped=true"
import script from "./AccordiDataTable.vue?vue&type=script&lang=js"
export * from "./AccordiDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afd2f3e",
  null
  
)

export default component.exports